import React, {FC} from 'react';
import {Markdown} from 'components/Markdown';
import {Screen} from 'pages/dashboard/components/FirstLook/Screens/Screen';

import * as styles from 'pages/dashboard/components/FirstLook/Screens/Factoid/styles.module.scss';

type InfoProps = {
	image: string
	text: string
}

export const Info: FC = (props) => {
	const info = props as InfoProps;
	return (
		<Screen>
			<div className={styles.factoid}>
				<div className={styles.image}>
					<img src={info.image} />
				</div>
				<div className={styles.text}>
					<Markdown markdown={info.text} />
				</div>
			</div>
		</Screen>
	);
};
